import { ADMIN_APP_TYPES, adminAppsTypesType } from '../consts/shared';
import Page1DashboardGraphs from '../pages/Page1DashboardGraphs';
import Page2DashboardGraphs from '../pages/Page2DashboardGraphs';
import Page3DashboardGraphs from '../pages/Page3DashboardGraphs';
import Page4DashboardGraphs from '../pages/Page4DashboardGraphs';
import Page5DashboardGraphs from '../pages/Page5DashboardGraphs';
import Page6DashboardGraphs from '../pages/Page6DashboardGraphs';

export const PagesList = (props: PagesCommonProps & { graphs?: any[] }) => [
  <Page1DashboardGraphs {...props} />,
  <Page2DashboardGraphs {...props} />,
  <Page3DashboardGraphs {...props} />,
  <Page4DashboardGraphs {...props} />,
  <Page5DashboardGraphs {...props} />,
  <Page6DashboardGraphs {...props} />,
]

export const PagesFilterOptionsByNumber = (
  pageNo: number,
  { Role, Site, Users, Ratings, Courses, Organisations, invertData, Authors, "eLearning/Events": eLearningEvents }: pagesFilterOptionsDataTypes,
) => {

  const filters = [
    { Organisations, Site, Role, invertData, "eLearning/Events": eLearningEvents },
    { Organisations, Site, Role, Users, "eLearning/Events": eLearningEvents },
    { Organisations, Site, Role, Courses, "eLearning/Events": eLearningEvents },
    { Organisations, Site, Role },
    { Organisations, Courses, Authors, Ratings },
    { Organisations },
  ];

  return filters[pageNo] as unknown as FilterOptions;
}

/**
 * Get valid filter names for a page number
 * Uses the same logic as PagesFilterOptionsByNumber to ensure consistency
 * @param pageNo - Page number (0-indexed)
 * @returns Array of filter names valid for the page
 */
export const getValidFilterNamesByPage = (pageNo: number): string[] => {
  const filterOptions = PagesFilterOptionsByNumber(pageNo, {
    Role: [],
    Site: [],
    Users: [],
    Ratings: [],
    Courses: [],
    Organisations: [],
    invertData: [],
    Authors: [],
    Team: [],
    "eLearning/Events": [],
  });
  
  return Object.keys(filterOptions);
}

/**
 * Get date and range filter names for a page (fallback case when API data is not available)
 * This maps page numbers to their date/range filter support
 * @param pageNo - Page number (0-indexed)
 * @returns Object with dateFilterNames and rangeFilterNames arrays
 */
export const getDateRangeFiltersByPage = (pageNo: number): {
  dateFilterNames: string[];
  rangeFilterNames: string[];
} => {
  // Based on default dashboard configuration:
  // Page 4 (index 3): Site Usage - has datepicker
  // Page 5 (index 4): Course Rating - has datepicker
  // Page 6 (index 5): Credit Management - has datepicker and rangepicker
  const dateFilterNames: string[] = [];
  const rangeFilterNames: string[] = [];
  
  if (pageNo === 3 || pageNo === 4 || pageNo === 5) {
    dateFilterNames.push('startDate', 'endDate');
  }
  
  if (pageNo === 5) {
    rangeFilterNames.push('MinRange', 'MaxRange', 'MinRangePercent', 'MaxRangePercent');
  }
  
  return { dateFilterNames, rangeFilterNames };
}

export const pageHeadings = [
  "Organisation Overview",
  "User Overview",
  "Course Overview",
  "Site Usage",
  "Course Rating",
  "Credit Management",
];

export type PagesCommonProps = { 
  graphs?: any[],
  filters: Record<string, any>,
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>,
};

export type pagesFilterOptionsDataTypes = {
  Site: string[],
  Role: string[],
  Team: string[],
  Users: string[],
  Author?: string[],
  Authors?: string[],
  Ratings: string[],
  Courses: string[],
  Credits?: string[],
  invertData: string[],
  Organisations: string[],
  "eLearning/Events"?: string[],
  lastSyncedDate?: string,
  MinCreditRange?: number,
  MaxCreditRange?: number,
  MinCreditRangePercent?: number,
  MaxCreditRangePercent?: number,
};

export const pagesFilterOptionsData = {
  Site: [],
  Role: [],
  Users: [],
  Author: [],
  Authors: [],
  Team: [],
  Courses: [],
  Organisations: [],
  lastSyncedDate: "",
  withCourses: "true",
  orgsWithCredits: "true",
  completedCourses: "true",
  mostCompletedUser:  "true",
  Ratings: ["1", "2", "3", "4", "5"],
  "eLearning/Events": ["eLearning", "events"],
  invertData: ["Most compliant", "Least compliant"],
  Credits: ["0%", "1-25%", "26-50%", "51-75%", "76-99%", "100%"],
};

export type FilterOptions = {
  [key: string]: string[];
};

export const AdminsPagesFilterOptions = (
  { Site, Role, Users, Team }: pagesFilterOptionsDataTypes,
  adminType: adminAppsTypesType = ADMIN_APP_TYPES.ADMIN,
) => {

  const filters: FilterOptions = { Site, Role, Users };
 /* if (adminType === ADMIN_APP_TYPES.MANAGER) {
    filters.Team = Team;
  }*/

  return filters;
}